// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9078) return "static/chunks/9078-c9b7b88af9125ab6.js";
	if (chunkId === 8512) return "static/chunks/8512-9c504c1a85f84c82.js";
	if (chunkId === 9461) return "static/chunks/9461-8fcb4cee4430d11c.js";
	if (chunkId === 9325) return "static/chunks/9325-fb047bf245a2771d.js";
	if (chunkId === 706) return "static/chunks/706-31101966572cd977.js";
	if (chunkId === 2535) return "static/chunks/2535-975c3fe26d78b4ef.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3678":"47bf8baf","7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"307":"66ef02153e25c149","497":"99699f898dfb998b","2570":"cedbb773b631465a","3678":"b8cd9a88b2e07c50","4379":"82d2d7b0cdce34c9","6113":"73c81ac07e44ae72","7538":"7733f92138dbbecd","7907":"64e5d9663c10561c","7937":"a75c66cdafb4d5b8","9807":"b3936944dfbf3490","9983":"8489c41bfe24dbad"}[chunkId] + ".js";
};